import { useLocation } from 'react-router-dom';

export function getActiveTabPageTaxCoupon() {
  const useHook = () => {
    const { pathname } = useLocation();
    const pathnames = pathname.split('/');
    const basePath = '/' + pathnames.slice(1, -1).join('/');
    const baseKey = pathnames.slice(-2)[0];

    return { baseKey, basePath };
  };

  return useHook();
}
